export default {
    title: 'ตัวอักษรเมล็ดพันธุ์',
    intro: `ตัวอักษรเมล็ดพันธุ์ช่วยให้เรียนรู้หลักการและกระบวนการว่าคำถูกสร้างขึ้นอย่างไร <br>โดยการสังเกต 'ตัวอักษร' และ 'คำที่ใช้ตัวอักษรนั้น' ผ่านการฝึกฝน <br>ตัวอักษรเมล็ดพันธุ์ เราจะเดาความหมายของคำที่ไม่รู้จักได้ง่ายขึ้น`,
    quizIntro: 'ลองนึกถึงตัวอักษรที่เรียนมาแล้วทำโจทย์กันดูสิ',
    header: {
        navigator: 'เลเวล {level} ครั้งที่ {round}',
    },
    subject: {
        letter: 'ฝึกตัวอักษรเมล็ดพันธุ์',
        relation: 'ตรวจสอบความสัมพันธ์เชิงความหมาย',
        board: 'ตัวอักษรเมล็ดพันธุ์ที่ฉันเรียน',
        lesson: 'การฝึกตัวอักษรเมล็ดพันธุ์',
        quiz: 'แบบทดสอบย่อยตัวอักษรเมล็ดพันธุ์',
    },
    indicator: {
        letter: 'มาเรียนรูปร่าง เสียง และความหมายของตัวอักษรเมล็ดพันธุ์กัน',
        word: 'มาเรียนว่าตัวอักษรเมล็ดพันธุ์ถูกใช้ในคำอย่างไร',
        words: 'มาเรียนสองคำที่มีตัวอักษรเมล็ดพันธุ์อยู่',
        choose1: 'สองคำด้านล่างมีตัวอักษรที่ใช้ร่วมกันอยู่ <br/>',
        choose2: "ในสองคำนี้ คำที่ใช้ตัวอักษร 'word' คือคำใด?",
        relation: 'ความสัมพันธ์ระหว่าง { first } กับ { second } คืออะไร?',
        quiz: 'ตัวอักษรที่เหมาะจะเติมในช่องว่างคือตัวใด?',
    },
    study: {
        example: 'ประโยคตัวอย่าง',
        meaning: 'ความหมาย',
        sound: 'เสียง',
        listen: 'ฟังเสียง',
    },
    modal: {
        notCompleted: 'สามารถเรียนได้หลังจากเรียนรอบก่อนหน้าครบทั้งหมดแล้ว',
        moveToWaiting: 'ต้องการไปที่ห้องรอหรือไม่?',
        invalidAccess: 'เป็นการเข้าถึงที่ไม่ถูกต้อง',
    },
    exitModal: {
        title: 'การฝึกยังไม่จบเลย!',
        message: 'หากหยุดตอนนี้ เนื้อหาการฝึกอาจไม่ถูกบันทึก!',
        continue: 'ทำต่อ',
        stop: 'หยุด',
    },
    result: {
        totalQuestionMessage: 'ตอบถูก score ข้อ จากทั้งหมด total ข้อ',
        checkMessage: 'ลองตรวจสอบคำตอบที่ถูกทั้งหมดอย่างละเอียดดูสิ',
        correct: 'ตอบถูก',
        selected: 'เลือก',
        incorrect: 'ตอบผิด',
    },
    toast: {
        wrongAnswer: {
            lead: 'มาลองคิดใหม่กันไหม?',
            body: 'ดูความหมายแล้วเลือกคำที่ถูกต้องดูสิ',
        },
    },
    button: {
        nextWord: 'เรียนต่อ',
        nextLevel: 'ไปเลเวลถัดไป',
        start: 'เริ่ม',
        finishStudy: 'จบการเรียน',
        finishExam: 'จบการสอบ',
        confirm: 'ยืนยัน',
    },
    relation: {
        synonym: {
            name: 'คำพ้องความหมาย',
            description: 'ตัวอักษรสองตัวมีรูปร่างต่างกัน<br />  แต่มีความหมายคล้ายกัน',
        },
        opposite: {
            name: 'คำตรงข้าม',
            description: 'ตัวอักษรสองตัวมีความหมาย<br /> ตรงกันข้ามกัน',
        },
        hierarchy: {
            name: 'ลำดับชั้น',
            description: 'ความหมายของตัวอักษรตัวหนึ่ง<br /> ครอบคลุมความหมายของอีกตัว',
        },
        same: {
            name: 'พ้องรูป',
            description: ' ตัวอักษรสองตัวเขียนแบบเกาหลีเหมือนกัน<br/>แต่มีความหมายต่างกัน',
        },
        different: {
            name: 'หลายความหมาย',
            description: 'ตัวอักษรตัวหนึ่ง<br /> มีความหมายหลายอย่าง',
        },
    },
};
